import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EcrComponent } from './ecr/ecr.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EcrstatusComponent } from './ecrstatus/ecrstatus.component';
import { EcrhradminComponent } from './ecrhradmin/ecrhradmin.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HttpClientModule } from '@angular/common/http';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { EcrCalendarViewComponent } from './ecr-calendar-view/ecr-calendar-view.component';
import { CalendarModule, DateAdapter, CalendarMonthModule } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { LoginComponent } from './login/login.component';
import { TeamAuthGuardGuard } from './team-auth-guard.guard';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
// import { AllownumbersonlyDirective } from './allownumbersonly.directive'; 
import { BtnCellRenderer, EcrForHrComponent } from './ecr-for-hr/ecr-for-hr.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { ButtonCellRendererComponent } from './agModules/button-cell-renderer/button-cell-renderer.component';
import { MemberprofileComponent } from './memberprofile/memberprofile.component';
import { MemberjoininglistComponent } from './memberjoininglist/memberjoininglist.component';
import { MembernewjoinerComponent } from './membernewjoiner/membernewjoiner.component';
import { OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { DatePipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ViewReporteesECRComponent } from './view-reportees-ecr/view-reportees-ecr.component';
import { ViewThrReporteeComponent } from './view-thr-reportee/view-thr-reportee.component';
import { VersionCheckService } from './service/version-check.service';
import { EmailConfigurationComponent } from './email-configuration/email-configuration.component';
import { WebSocketService } from './service/web-socket.service';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { DriverClaimApprovalComponent } from './driver-reimbursement/driver-claim-approval/driver-claim-approval.component';

const config: SocketIoConfig = { url: 'ws://localhost:8181', options: {} };

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {

  //url: 'https://localhost:44375/API/ecr/PostECRFiles',
  // url: 'http://10.11.4.6:8885/API/ecr/PostECRFiles',
  url: 'https://teamworks.teamcomputers.com/api/API/ecr/PostECRFiles',
  //url:'http://14.143.36.132:9099/api/api/ecr/PostECRFiles',
   headers: {
    'X-Api-Key': 'TW-19604-A9F8327PM2026'
  },
  method: 'POST',
  maxFilesize: 500,
  timeout: 360000,
  //  uploadMultiple:true,
  //  parallelUploads: 10,
  acceptedFiles: '.jpeg,.jpg,.png,.gif,.mp4,.pdf,.xls,.xlsx,.txt,.doc,.docx,.csv,.ppt,.pptx,application/vnd.ms-excel',
  addRemoveLinks: true,
  dictRemoveFile: "Delete",
  //  previewsContainer: '.dropzone-previews' 
};
@NgModule({
  declarations: [
    //CalendarEventActionsComponent,
    // CalendarEventTitleComponent,    
    AppComponent,
    EcrComponent,
    EcrstatusComponent,
    EcrhradminComponent,
    EcrCalendarViewComponent,
    LoginComponent,
    //AllownumbersonlyDirective, 
    EcrForHrComponent,
    BtnCellRenderer,
    ButtonCellRendererComponent,
    MemberprofileComponent,
    MemberjoininglistComponent,
    MembernewjoinerComponent,
    DashboardComponent,
    ViewReporteesECRComponent,
    ViewThrReporteeComponent,
    EmailConfigurationComponent,
    DriverClaimApprovalComponent
  ],
  imports: [
    BrowserModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    AgGridModule.withComponents([ButtonCellRendererComponent]),
    OwlDateTimeModule,
    NgSelectModule,
    OwlNativeDateTimeModule,
    NgxDocViewerModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AutocompleteLibModule,
    AngularEditorModule,
    AngularMultiSelectModule,
    HttpClientModule,
    HttpClientModule,
    AngularEditorModule,
    DropzoneModule,
    BrowserAnimationsModule,
    NgMultiSelectDropDownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    CalendarMonthModule,
    SocketIoModule.forRoot(config),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    //  CalendarEventActionsComponent,
    // CalendarEventTitleComponent   
  ],
  providers: [VersionCheckService, WebSocketService, {
    provide: DROPZONE_CONFIG,
    useValue: DEFAULT_DROPZONE_CONFIG
  }
    , NgxSpinnerService
    , { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' },
    DatePipe,
  ],
  entryComponents: [
    BtnCellRenderer
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


